export const APP_CLIENT_ID = "app.migiri.purple.webonboarding";

export const QUERY_PARAM_REDIRECTION_STATUS = "redirect_status";
export const QUERY_PARAM_SETUP_INTENT = "setup_intent";
export const QUERY_PARAM_SETUP_INTENT_CLIENT_SECRET =
  "setup_intent_client_secret";

export const QUERY_PARAM_PAYMENT_INTENT = "payment_intent";

// Carries the chosen plan across the Stripe redirect into /welcome-onboard.
export const QUERY_PARAM_PLAN = "plan";

export const REDIRECTION_STATUS_SUCCEEDED = "succeeded";

export const ROUTE_WELCOME_ONBOARD = "/welcome-onboard";
export const ROUTE_SIGN_IN = "/sign-in";
export const ROUTE_SUBSCRIBE = "/subscribe";
export const ROUTE_FREE_TRIAL = "/free-trial";
export const ROUTE_FREE_TRIAL_B = "/free-trial_b";

export const ROUTE_WELCOME_ONBOARD_SANITIZED = `${ROUTE_WELCOME_ONBOARD}?${QUERY_PARAM_REDIRECTION_STATUS}=${REDIRECTION_STATUS_SUCCEEDED}`;
